import { Currency } from "components/CustomCurrency/currency";
import { Unit } from "components/CustomUnits/units";
import DataTable from "examples/Tables/DataTable";

export function formatData(data) {
  // :param: data: [
  //   {
  //     "laboratory": "LAQUINSA",
  //     "name": "ACRILÁN",
  //     "category": "ANTISEPTICOS Y CICATRIZANTES",
  //     "presentation": "TUBO",
  //     "quarter1Sales": 2698.14,
  //     "quarter2Sales": 3560.85,
  //     "quarter3Sales": 4562.52,
  //     "quarter4Sales": 0,
  //     "quarter1Quantity": 466,
  //     "quarter2Quantity": 615,
  //     "quarter3Quantity": 788,
  //     "quarter4Quantity": 0,
  //     "description": "ACRILÁN - ANTISEPTICOS Y CICATRIZANTES - ACRIFLAVINA - TUBO - 50 GR"
  // }
  // ]
  let _rows = [];

  data.forEach((elem, index) => {
    let totalQuarterSales =
      elem.quarter1Sales + elem.quarter2Sales + elem.quarter3Sales + elem.quarter4Sales;
    let totalQuarterQuantity =
      elem.quarter1Quantity + elem.quarter2Quantity + elem.quarter3Quantity + elem.quarter4Quantity;
    _rows.push({
      nro: index + 1,
      name: elem.name,
      presentation: elem.presentation,
      collapse: elem.description,
      collapseTable: (
        <DataTable
          table={{
            columns: [
              { Header: "Trimestre", accessor: "quarter" },
              { Header: "Unidades", accessor: "unit" },
              { Header: "Ventas", accessor: "sale" },
              { Header: "Valor Unitario", accessor: "value" },
            ],
            rows: [
              {
                quarter: "Primer Trimestre",
                unit: <Unit value={elem.quarter1Quantity}></Unit>,
                sale: <Currency value={elem.quarter1Sales}></Currency>,
                value: (
                  <Currency
                    value={
                      Number(elem.quarter1Quantity) === 0
                        ? 0
                        : Number(elem.quarter1Sales) / Number(elem.quarter1Quantity)
                    }
                  ></Currency>
                ),
              },
              {
                quarter: "Segundo Trimestre",
                unit: <Unit value={elem.quarter2Quantity}></Unit>,
                sale: <Currency value={elem.quarter2Sales}></Currency>,
                value: (
                  <Currency
                    value={
                      Number(elem.quarter2Quantity) === 0
                        ? 0
                        : Number(elem.quarter2Sales) / Number(elem.quarter2Quantity)
                    }
                  ></Currency>
                ),
              },
              {
                quarter: "Tercer Trimestre",
                unit: <Unit value={elem.quarter3Quantity}></Unit>,
                sale: <Currency value={elem.quarter3Sales}></Currency>,
                value: (
                  <Currency
                    value={
                      Number(elem.quarter3Quantity) === 0
                        ? 0
                        : Number(elem.quarter3Sales) / Number(elem.quarter3Quantity)
                    }
                  ></Currency>
                ),
              },
              {
                quarter: "Cuarto Trimestre",
                unit: <Unit value={elem.quarter4Quantity}></Unit>,
                sale: <Currency value={elem.quarter4Sales}></Currency>,
                value: (
                  <Currency
                    value={
                      Number(elem.quarter4Quantity) === 0
                        ? 0
                        : Number(elem.quarter4Sales) / Number(elem.quarter4Quantity)
                    }
                  ></Currency>
                ),
              },
              {
                quarter: "Totales",
                unit: <Unit value={totalQuarterQuantity}></Unit>,
                sale: <Currency value={totalQuarterSales}></Currency>,
                value: (
                  <Currency
                    value={
                      Number(totalQuarterQuantity) === 0
                        ? 0
                        : Number(totalQuarterSales) / Number(totalQuarterQuantity)
                    }
                  ></Currency>
                ),
              },
            ],
          }}
          canSearch={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder={true}
          isSorted={false}
        />
      ),
    });
  });
  return {
    columns: [
      { Header: "Nro", accessor: "nro", width: "10%" },
      { Header: "Nombre", accessor: "name" },
      { Header: "Presentación", accessor: "presentation" },
    ],
    rows: _rows,
  };
}
